module.exports = __webpack_public_path__ + "img/qingfengAppImage.580cfca9.png";